import { render, staticRenderFns } from "./CustomCheck2.vue?vue&type=template&id=7b50d13d"
import script from "./CustomCheck2.vue?vue&type=script&lang=js"
export * from "./CustomCheck2.vue?vue&type=script&lang=js"
import style0 from "./CustomCheck2.vue?vue&type=style&index=0&id=7b50d13d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports